define(function (require) {

    var BaseCategoriesWidget = require('web-agent-widgets/BaseCategoriesWidget');
    var VisitInfoBase = require('web-agent-widgets/VisitInfoBase');

    var VisitInfoWidget = VisitInfoBase.extend({
        ControllerName: "VisitInfoWidget",
        applicationType: "VisitInfoWidget",

        events: function () {
            if (!this.singleton || !this.tableName) {
                this.bindModel({modelPath : this.getEngagementInfoModelPath() + ".sessionId", callback : this.handleSessionIdChanged});
                this.bindModel({modelPath : this.getEngagementInfoModelPath() + ".appServerVisitorId", callback : this.handleServerVisitorIdChanged});
            }
        }
    });

    VisitInfoWidget.prototype.getConfiguration = function () {
        var configuration = {
            updateDataCallback: this.startPollingVisitorInfo,
            useDataInPath: true
        };
        return configuration;
    };

    VisitInfoWidget.prototype.onSelectedVisitorChanged = function (data) {
        if (!data.newValue || !data.newValue.eventData) {
            return;
        }

        if (!this.configuration || !this.configuration.itemIdTag || !data.newValue.eventData[this.configuration.itemIdTag]) {
            return;
        }
        var newVisitorId = data.newValue.eventData[this.configuration.itemIdTag];
        if (this.visitorId && this.visitorId !== newVisitorId) {
            this.unbindModel({modelPath :  this.getRootModelPath(), callback: this.handleVisitInfoChanged});
            this.appSrvId = null;
            this.sessionId = null;
            this.stopPollingVisitorInfo();
        }
        BaseCategoriesWidget.prototype.onSelectedVisitorChanged.call(this, newVisitorId);
        this.bindToModel();
        this.appSrvId = data.newValue.eventData.appSrvId;
        this.sessionId = data.newValue.eventData.sessionId;
        this.startPollingVisitorInfo();
    };

    VisitInfoWidget.prototype.startPollingVisitorInfo = function () {
        lpTag.WebAgent.visitorInfoController.startPollingVisitorInfo(this.visitorId, this.appSrvId, this.sessionId);
    };

    VisitInfoWidget.prototype.stopPollingVisitorInfo = function () {
        lpTag.WebAgent.visitorInfoController.stopPollingVisitorInfo(this.visitorId);
    };

    VisitInfoWidget.prototype.handleWidgetsClosed = function () {
        BaseCategoriesWidget.prototype.unbindEvents.call(this);
        this.stopPollingVisitorInfo();
    };
    VisitInfoWidget.prototype.handleServerVisitorIdChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        this.appSrvId = data.newValue;
    };

    VisitInfoWidget.prototype.handleSessionIdChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        this.sessionId = data.newValue;
    };

    return VisitInfoWidget;

});
